module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/185W96X/tc-custom/9781459237148.jpg?1720116011014",
      "alt": "This image is the cover for the book One Night in Paradise"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("One Night in Paradise\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The Scoundrel's Seduction")]), _c('br'), _c('br'), _vm._v("Though Queen Elizabeth I’s court at Richmond was a notorious hotbed of illicit liaisons and broken hearts, only beautiful Adorna Pickering remained unscathedand unattainable. For whenever an admirer crossed the line, she sought the protection of her father, the Master of Revels."), _c('br'), _c('br'), _vm._v("Only one man held the power to overcome her skittish waysSir Nicholas Rayne. With a reputation blacker than sin, Nicholas represented everything Adorna knew to avoid. But how could she remain indifferent when his slightest touchhis very "), _c('i', [_vm._v("boldness")]), _vm._v("left her weak with desire? And though Adorna didn’t want to be just another easy conquest, she’d willingly forsake "), _c('i', [_vm._v("everything")]), _vm._v(" she held dear for one night spent in his arms.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Juliet Landon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Juliet Landon is a professional embroiderer and lecturer, whose two disciplines go perfectly hand in hand. When she’s not doing one, she’s doing the other, often both on the same day. Her stories develop in her mind while stitches form on the fabric, and the one that wins depends on urgency and inclination. Juliet has been nominated for the Romantic Fiction Writer's Award, and she currently has at least another hundred ideas waiting to be released in the future.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0